import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import PropTypes from 'prop-types';

export default function CheckboxInput(props) {

  const { errors, label, helperText, labelClassName, ...checkboxProps } = props;

  return (
    <FormControl error={!!errors} className='checkbox-input'>
      <FormControlLabel
        control={
          <Checkbox
            {...checkboxProps}
            color="primary"
          />
        }
        label={label}
        className={labelClassName}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {errors && <FormHelperText>{errors.message}</FormHelperText>}
    </FormControl>
  )
}

CheckboxInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  errors: PropTypes.object,
  helperText: PropTypes.string,
}
